import { ref as storageRef, getDownloadURL } from "firebase/storage";
import { storage } from "../firebaseConfig";

export async function fetchCsvTextFromStorage(path) {
  try {
    const url = await getDownloadURL(storageRef(storage, path));
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) return null;
    return await res.text();
  } catch {
    return null;
  }
}

export async function fetchJsonFromStorage(path) {
  try {
    const url = await getDownloadURL(storageRef(storage, path));
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) return null;
    const json = await res.json();
    if (!json || typeof json !== "object") return null;
    return json;
  } catch {
    return null;
  }
}
